import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import {Context as SalesChannelsContext} from '../../contexts/SalesChannels'
import ObjectForm from '../../components/ObjectForm'

import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

const StockCostCreate = ({open, close, model, ...rest}) => {
  const app = React.useContext(AppContext)
  const { clients } = app.clients
  const AmazonSalesChannel = React.useContext(SalesChannelsContext)
  const { recall, setRecall } = AmazonSalesChannel
  const { create, update } = AmazonSalesChannel.stockCosts

  const title = model?"Actualizar":"Añadir"
  const client = model? clients.find(c => c.id == model.clientId): null
  return (
    <Dialog onClose={close} open={open}>
      <DialogTitle>{title}</DialogTitle>
      <ObjectForm ignored={['id']} recall={recall} submit={create}
        stc={{ vendor: app.vendor }}
        obj={model || {date:'', guide:'', clientId:'', cost:'', method:'', description:''}}
        labels={{date:'Fecha', guide:'N. Guía', clientId:'Cliente', cost:'Costo', method:'Método', description:'Descripcion'}}
        types={{date:'date', guide:'text', clientId:'select', cost:'money',  method:'text', description: 'text'}}
        options={{clientId:clients.map(c => {return{value:c.id,label:c.name}})}} 
        controlled={{cost:model?model.cost:0, date:model?model.date:null}}
        changed={{...model, clientId:client?client.id:null} || {}} 
      />
      <Button onClick={() => {setRecall(true);close()}}>{title}</Button>
    </Dialog>
  )
}
export default StockCostCreate